<template>
    <div class="gz-swiper popout" v-loading.fullscreen.lock='loading' element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
        <!-- 列表 -->

        <div class="table_cm">

            <div class="bgc-header">
                <div class="search-item">
                    <span style="color: #666;">{{ childData.shelfname }}-库位明细</span>
                    <div>
                        <!-- <el-button type="primary" size="small" @click="exportCode">批量导出二维码</el-button> -->
                        <el-button type="primary" size="small" @click="addContainer">+ 新建库位</el-button>
                        <el-button type="primary" size="small" @click="getBack">返回</el-button>
                    </div>

                </div>
                <div class="el-icon">
                    <i class="el-icon-warning-outline"></i>已绑定 <span style="color: #0090f0;">{{ childData.insNum || 0
                        }}</span> 个仪器
                </div>
            </div>
            <el-table @selection-change="handleSelectionChange" :data="PowerInfo" style="width: 100%" height="740"
                element-loading-background="rgba(0, 0, 0, 0.1)">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="storename" label="库位名称" align="center">
                </el-table-column>
                <el-table-column prop="instrumentName" label="仪器名称" align="center">
                </el-table-column>
                <el-table-column prop="instrumentNo" label="仪器编号" align="center">
                </el-table-column>
                <el-table-column prop="number" label="排序" align="center">
                </el-table-column>
                <el-table-column prop="createtime" label="创建时间" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="180">
                    <template slot-scope="scope">

                        <el-button type="text" size="small"
                            @click.native.prevent="editContainer(scope.row, scope.$index)">编辑</el-button>
                        <el-button type="text" size="small" v-if="!scope.row.instrumentNo"
                            @click.native.prevent="binding(scope.row)">绑定</el-button>
                        <el-button type="text" size="small" v-if="scope.row.instrumentNo"
                            @click.native.prevent="unbundle(scope.row)">解绑</el-button>
                        <el-button type="text" size="small" style="color: red;"
                            @click.native.prevent="delContainer(scope.row.id)"  :disabled="scope.row.instrumentNo">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <div class="resource-block" v-if="PowerInfo.length > 0">
            <el-pagination background prev-text="前一页" next-text="后一页" layout="prev, pager, next" :total="total"
                :current-page.sync="currentPage" :page-size="pageSize" @current-change="pageChange"></el-pagination>
        </div>
        <div class="addModel myDialog">
            <el-dialog title="新增库位" :visible.sync="visible" width="500px">
                <div class="addModel myinput">
                    <div>
                        <div class="emid">
                            <div>
                                <span>库位名称</span>
                                <el-input v-model="query.storename" maxlength="100"></el-input>
                            </div>
                            <div>
                                <span>排序</span>
                                <el-input v-model="query.number"
                                    @input="query.number = query.number.replace(/[^\d]/g, '')"
                                    maxlength="10"></el-input>
                            </div>

                        </div>
                    </div>
                    <div class="detailed">
                        <div class="element-list jb-bg btn" @click="submit">确认</div>
                        <div class="element-list jb-bg btn" @click="visible = false">取消</div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <div class="addModel myDialog">
            <el-dialog title="绑定仪器" :visible.sync="pbindVisible" v-if="pbindVisible" width="400px">
                <instrumentList @pcheckValue="pcheckValue" :type="1" @cancel="pbindVisible = false"></instrumentList>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getShelfById,
    storeShelf,
    getStoreMaxNumber,
    storeDelete,
    storeBind,
    exportQrcodeStore,
    unBind
} from "@/api/warehouse";
import instrumentList from "./instrumentList";
export default {
    name: "powerSwiper",
    components: {
        instrumentList
    },
    props: {
        depotInfo: {
            type: Object,
            default: {},
        },
        childData: {
            type: Object,
            default: {},
        }
    },
    inject: ["reload"],
    data() {
        return {
            multipleSelection: [],
            pInfo: null,
            pbindVisible: false,
            cloumns: [],
            visible: false, //电源控制器修改弹窗
            depotId: "", //仓库id
            PowerInfo: [], //电源控制器列表
            currentPage: 1, //当前页数
            pageSize: 10, //每页显示数量
            total: 0, //总数
            loading: false,
            query: {
                number: "",
                storename: ''
            }
        }
    },
    watch: {
        depotInfo: {
            handler(val) {
                this.depotId = val.id;
                this.getPowerList();
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        exportCode() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请勾选需要导出的库位',
                    type: 'warning'
                });
                return
            }
            let ids = this.multipleSelection.map(it => it.id)
            exportQrcodeStore(ids).then((res) => {
                this.mixin.blobDownload(res.data,'库位.xlsx');
            }).catch((error) => {
                this.mixin.blobErrorTip(error);
            });
        },
        async addContainer() {
            this.pInfo = null
            try {
                this.query = {
                    storename: null,
                    number: await getStoreMaxNumber({ depotid: this.depotId, shelfId: this.childData.id })
                }
                this.visible = true;
            } catch (error) {
                console.log(error, 'error')

            }

        },
        editContainer(row, index) {
            this.pInfo = row
            Object.assign(this.query, row)
            this.visible = true;
        },

        submit() {
            if (!this.query.storename) {
                return this.$message.error("请输入库位名称");
            }
            if (!this.query.number) {
                return this.$message.error("请输入排序");
            }

            storeShelf({ ...this.query, depotId: this.depotId, shelfid: this.childData.id }).then((res) => {
                if (res.code == 200) {
                    this.visible = false;
                    this.$message.success(this.pInfo ? '修改成功' : "新增成功!");
                    this.getPowerList();
                } else {

                    this.$message.error(res.msg || "网络请求错误");
                }
            })
                .catch((err) => {

                    this.$message.error(err.msg || err.message || "网络请求错误");
                });

        },
        getBack() {
            this.$emit('change', null, 'containerSwiper')
        },

        // 点击页码操作
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getPowerList();
        },
        inquire() {
            this.currentPage = 1;
            this.getPowerList();
        },
        reset() {

            this.currentPage = 1;
            this.getPowerList();
        },
        //获取电源控制器信息
        getPowerList() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                depotId: this.depotId,
                shelfId: this.childData.id
            };
            this.loading = true;
            getShelfById(params)
                .then((res) => {
                    if (res.code == 200) {
                        this.PowerInfo = res.data.records;
                        this.total = res.data.total;
                    } else {
                        this.PowerInfo = [];
                        this.$message.error(res.msg || "网络请求错误");
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.PowerInfo = [];
                    this.loading = false;
                    this.$message.error(err.msg || err.message || "网络请求错误");
                });
        },
        binding(row) {
            this.pInfo = row
            this.pbindVisible = true;
        },
        // 电源控制器绑定仪器提交
        pcheckValue(val) {
            let params = {
                depotId: this.depotId,
                shelfId: this.childData.id,
                instrumentid: val,
                id: this.pInfo.id
            };
            storeBind(params).then((res) => {
                if (res.code == "200") {
                    this.pbindVisible = false;
                    this.$message.success("绑定成功！");
                    this.getPowerList();
                } else {
                    this.pbindVisible = false;
                    this.$message.error("绑定失败！");
                }
            });
        },
        //分页功能
        pageChange(page) {
            this.currentPage = page;
            this.getPowerList();
        },

        unbundle(data) {
            this.$confirm("确认解绑 ？", "提示", {
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                type: "warning",
            }).then(() => {
                unBind({ id: data.id, instrumentid: data.instrumentid, depotId: this.depotId, shelfid: this.childData.id }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success("解绑成功成功!");
                        this.getPowerList();
                    } else {
                        this.$message.error("解绑失败！" + res.msg);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消解绑",
                });
            });
        },
        // 电源控制器删除
        delContainer(pid) {
            this.$confirm("确定删除该库位吗？", "删除提示", {
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                type: "warning",
            }).then(() => {
                storeDelete(pid).then((res) => {
                    if (res.code == "200") {
                        this.$message.success("删除成功!");
                        this.getPowerList();
                    } else {
                        this.$message.error("删除失败！" + res.msg);
                    }
                });
            })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },



        cancel() {

        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/commonStyle.less";

.resource-block {
    text-align: center;
}

.bindState-ybd {
    color: #3177EC
}

.bindState-ybd::before {
    content: '';
    width: 8px;
    display: inline-block;
    height: 8px;
    background-color: #3177EC;
    border-radius: 50%;
    margin-right: 3px;
}

.bindState-wbd::before {
    content: '';
    width: 8px;
    display: inline-block;
    height: 8px;
    background-color: #ccc;
    border-radius: 50%;
    margin-right: 3px;
}

.search-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 10px;
    margin-top: 10px;

    .myinput {
        width: 300px;
    }

}

.not_info {
    margin: 0 auto;
    margin-top: 20px;
    width: 1570px;
    color: #74c8fe;
    font-size: 24px;
    text-align: center;

    .info_text {
        margin-top: 320px;
    }
}

ul,
li {
    list-style: none;
    margin: 0;
    padding: 0;
}

.bgc-header {
    background-color: #fff;
    display: flex;
    flex-direction: column;

    .el-icon {
        height: 35px;
        line-height: 35px;
        background-color: #74c8fe38;
        color: #666;
        border: 1px solid #74c8fe38;
        width: 90%;
        border-radius: 4px;
        margin-left: 2%;
        margin-top: 10px;
        padding-left: 10px;

    }
}

.select_option {
    background: #092e5f !important;
    color: #ffffff !important;
}

.addModel {
    height: 450px;
    color: #74c8fe;
    margin: 0 30px;

    .addemBtns {
        margin: 30px 10px;
        font-size: 20px;
    }

    .emid {
        height: 50px;
        line-height: 65px;

        .el-input {
            width: 260px;
            margin: 0px 15px;
        }

        span {
            display: -moz-inline-box;
            display: inline-block;
            width: 85px;
            text-align: center;
            text-align-last: justify;
        }
    }

    .detailed {
        margin: 0 30px 20px;
        clear: both;
        display: flex;
        position: absolute;
        bottom: 0px;

        .btn {
            width: 150px;
            margin-right: 10px;
            cursor: pointer;
        }

        .element-list {
            border: 2px solid#0090F0;
            border-radius: 6px;
            height: 30px;
            line-height: 30px;
            margin: 10px 5px;
            text-align: center;
        }

        .jb-bg {
            background-image: linear-gradient(#0479b4, #02407e);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/warehouse/components/childContainerSwiper.vue